export default "__VITE_ASSET__CnQWyfB7__"